<template>
  <div>
    <div
      style="display: flex;"
      v-if="imagenInsitucion == null || imagenInsitucion == ''"
      class="nombreInstitucion"
    >
      <p
        class="mt-1"
        style="color:white;font-weight: 400;letter-spacing: 2px;text-align: center;margin: 0 auto;padding: 15px;font-size: 20px;"
      >
        <i class="fa fa-graduation-cap" aria-hidden="true"></i>{{ nombreInstitucion }}
      </p>
    </div>

    <div
      v-else
      style="display: flex;height: 120px;justify-content: center;padding-top: 20px;"
      class="nombreInstitucion"
    >
      <div>
        <p
          style="color:white;font-weight: 400;letter-spacing: 2px;text-align: center;margin: 0 auto;padding: 15px;font-size: 20px;"
        >
          <i class="fa fa-graduation-cap" aria-hidden="true"></i>{{ nombreInstitucion }}
        </p>
      </div>
      <div>
        <img
          style="height: 58px; border-radius: 5px 10px 10px;min-height:58px;"
          :src="dataUrl + 'archivos/' + 'instituciones_logos/' + imagenInsitucion"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstitutionBanner',
  props: {
    nombreInstitucion: {
      type: String,
      required: true
    },
    imagenInsitucion: {
      type: String,
      default: ''
    },
    dataUrl: {
      type: String,
      required: true
    }
  }
}
</script>
